import React, { useState } from "react";
import {
    useAddTodoMutation,
    useGetTodosQuery,
} from "../Redux/features/api/apiSlice";
import Footer from "./Footer";
import Header from "./Header";
import Todo from "./Todo";

const TodoList = () => {
    const [status, setStatus] = useState("");
    const [newTodo, setNewTodo] = useState("");
    const [addTodo] = useAddTodoMutation();
    const { data: todos, isLoading } = useGetTodosQuery(status);

    const submitHandler = async (e) => {
        e.preventDefault();
        const todo = {
            text: newTodo,
            completed: false,
            id: todos.length + 1,
        };
        await addTodo(todo);
        // refetch();
        setNewTodo("");
    };

    let content = null;

    if (isLoading) {
        content = <>Loading...</>;
    }
    if (todos?.length === 0) {
        content = <>No todos found!</>;
    }

    if (!isLoading && todos.length > 0) {
        content = todos.map((todo) => <Todo todo={todo} key={todo.id} />);
    }

    return (
        <>
            <Header {...{ submitHandler, newTodo, setNewTodo }} />
            <hr className="mt-4" />
            <div className="mt-2 text-gray-700 text-sm max-h-[300px] overflow-y-auto">
                {content}
            </div>
            <hr className="mt-4" />

            <Footer {...{ setStatus, status }} />
        </>
    );
};

export default TodoList;
